export default __webpack_public_path__ + "static/media/trade-speed-header-bg.013ed40e.jpg";